import { rateCurrency } from "./currency-rate";

// Pays proposés au choix et devise appliquée (ISO 3166-1 alpha-2 -> ISO 4217).
// Source unique pour la liste du client et la validation du serveur.
export const COUNTRY_CURRENCIES: Readonly<Record<string, string>> = {
  AO: "AOA", // Angola
  AT: "EUR", // Autriche
  BE: "EUR", // Belgique
  BF: "XOF", // Burkina Faso
  BI: "BIF", // Burundi
  BJ: "XOF", // Bénin
  BW: "BWP", // Botswana
  CA: "CAD", // Canada
  CD: "CDF", // République démocratique du Congo
  CF: "XAF", // République centrafricaine
  CG: "XAF", // Congo-Brazzaville
  CH: "CHF", // Suisse
  CI: "XOF", // Côte d’Ivoire
  CM: "XAF", // Cameroun
  CV: "CVE", // Cap-Vert
  DE: "EUR", // Allemagne
  DJ: "DJF", // Djibouti
  DZ: "DZD", // Algérie
  EG: "EGP", // Égypte
  ER: "ERN", // Érythrée
  ES: "EUR", // Espagne
  ET: "ETB", // Éthiopie
  FI: "EUR", // Finlande
  FR: "EUR", // France
  GA: "XAF", // Gabon
  GH: "GHS", // Ghana
  GM: "GMD", // Gambie
  GN: "GNF", // Guinée
  GQ: "XAF", // Guinée équatoriale
  GR: "EUR", // Grèce
  GW: "XOF", // Guinée-Bissau
  HT: "HTG", // Haïti
  IE: "EUR", // Irlande
  IT: "EUR", // Italie
  KE: "KES", // Kenya
  KM: "KMF", // Comores
  LB: "LBP", // Liban
  LR: "LRD", // Libéria
  LS: "LSL", // Lesotho
  LU: "EUR", // Luxembourg
  LY: "LYD", // Libye
  MA: "MAD", // Maroc
  MC: "EUR", // Monaco
  MG: "MGA", // Madagascar
  ML: "XOF", // Mali
  MR: "MRU", // Mauritanie
  MU: "MUR", // Maurice
  MW: "MWK", // Malawi
  MZ: "MZN", // Mozambique
  NA: "NAD", // Namibie
  NC: "XPF", // Nouvelle-Calédonie
  NE: "XOF", // Niger
  NG: "NGN", // Nigeria
  NL: "EUR", // Pays-Bas
  PF: "XPF", // Polynésie française
  PT: "EUR", // Portugal
  RW: "RWF", // Rwanda
  SC: "SCR", // Seychelles
  SD: "SDG", // Soudan
  SL: "SLE", // Sierra Leone
  SN: "XOF", // Sénégal
  SO: "SOS", // Somalie
  SS: "SSP", // Soudan du Sud
  ST: "STN", // Sao Tomé-et-Principe
  SZ: "SZL", // Eswatini
  TD: "XAF", // Tchad
  TG: "XOF", // Togo
  TN: "TND", // Tunisie
  TZ: "TZS", // Tanzanie
  UG: "UGX", // Ouganda
  US: "USD", // États-Unis
  VU: "VUV", // Vanuatu
  WF: "XPF", // Wallis-et-Futuna
  ZA: "ZAR", // Afrique du Sud
  ZM: "ZMW", // Zambie
  ZW: "ZWG", // Zimbabwe
};

// Taux d'affichage (1 FCFA = taux) des devises sans taux de débit dans rateCurrency.
// Ils ne servent jamais à débiter : le paiement mobile reste fermé pour ces devises.
export const DISPLAY_RATES: Readonly<Record<string, number>> = {
  AOA: 1.60756,
  BWP: 0.024186,
  CAD: 0.002448,
  CHF: 0.00144,
  CVE: 0.168098,
  EGP: 0.091048,
  ERN: 0.026242,
  ETB: 0.282224,
  GHS: 0.020054,
  GMD: 0.130737,
  HTG: 0.229422,
  KES: 0.226682,
  LBP: 156.578489,
  LRD: 0.304475,
  LSL: 0.028449,
  LYD: 0.011161,
  MRU: 0.070722,
  MUR: 0.082937,
  MWK: 3.058026,
  MZN: 0.111709,
  NAD: 0.028449,
  NGN: 2.331768,
  SCR: 0.024798,
  SDG: 0.898385,
  SLE: 0.043577,
  SOS: 1.004055,
  SSP: 9.910361,
  STN: 0.03735,
  SZL: 0.028449,
  TZS: 4.629918,
  UGX: 6.703222,
  VUV: 0.207305,
  XPF: 0.18192,
  ZAR: 0.028445,
  ZMW: 0.033969,
  ZWG: 0.04662,
};

// Devise disposant d'un taux de débit : seule acceptée par les fournisseurs de paiement mobile.
export const isDebitCurrency = (currency: string): boolean =>
  rateCurrency.some((entry) => currency in entry);

// Taux de référence : celui du débit s'il existe, sinon celui d'affichage.
export const getReferenceRate = (currency: string): number | undefined =>
  rateCurrency.find((entry) => currency in entry)?.[currency] ?? DISPLAY_RATES[currency];
